import { combineReducers } from 'redux';
import {calendarList} from './calendarList'
import {calendar} from './calendar';
import {user} from './user';
import {blog} from './blog';
import {adminPlaces} from './adminPlaces';
import {usersSocket} from './usersSocket';

export default combineReducers({
    calendar,
    user,
    calendarList,
    blog,
    adminPlaces,
    usersSocket
});

export const getPlaces = (state) => {return state.calendar.toDolist}
export const getweather = (state) => {return state.calendar.weather}
export const getUserToken = (state) => {return state.user.token}
export const getUserShopCarList = (state) => {return state.user.list}
export const getplacesList = (state) => {return state.user.places}
export const getNItemsList = (state) => {return state.user.Nitems}

export const getCalendarList = (state) => {return state.calendarList.list}
export const getCalendarInvList = (state) => {return state.calendarList.invList}
export const getCalendarListCount = (state) => {return state.calendarList.Nitems}

export const getUsersSocket= (state) => {return state.usersSocket.users}
export const getUsersMsg = (state) => {return state.usersSocket.msgs}

export const getAgendaPlaces = (state) => {return state.calendar.agendaList}
export const getAgendadays = (state) => {return state.calendar.dayAgenda}
export const getpublic = (state) => {return state.calendar.public}
export const getIsLoading = (state) => {return state.calendar.isLoading}
export const getIsErrorLoad = (state) => {return state.calendar.errorLoad}
export const getName = (state) => {return state.calendar.name}
export const getUnregistercustomers = (state) => {
    
    return {
        editors: state.calendar.emailsEditInv,
        viewer: state.calendar.emailsViewInv
    }}
export const getusers = (state) => {return state.calendar.users}
export const getinv = (state) => {return state.calendar.inv}
export const getCity = (state) => {return state.calendar.city}
export const getCityName = (state) => {return state.calendar.cityName}
export const getCityNameEn = (state) => {return state.calendar.cityNameEn}
export const getCityEmoji = (state) => {return state.calendar.cityEmoji}
export const getCityDataCoor = (state) => {return state.calendar.cityDataCoor}
export const getMaxDate = (state) => {return state.calendar.maxDate}
export const getMinDate = (state) => {return state.calendar.minDate}
export const getStartDate = (state) => {return state.calendar.startDate}
export const getStartAtTime = (state) => {return state.calendar.startAtTime}

export const getBlogsList = (state) => {return state.blog.blogs}
export const getNBlogsList = (state) => {return state.blog.Nitems}

export const getAdminPlacesList = (state) => {return state.adminPlaces.places}
export const getAdminPlacesListPage = (state) => {return state.adminPlaces.page}
export const getNAdminPlacesList = (state) => {return state.adminPlaces.Nitems}